(() => {
  let initialized = false;
  const kachingBundle = document.querySelector("kaching-bundle");
  if (!kachingBundle) return;

  const quantitySelector = document.querySelector(".quantity-selector--pdp");
  const pricePDP = document.querySelector(".price-pdp:not(.hidden) h3");
  const percentageElement = document.querySelector(".price-pdp:not(.hidden) .badge");
  const compareAtPriceEl = document.querySelector(".price-pdp:not(.hidden) h5");
  const priceEl = document.querySelector(".product-info price-element");
  const taxRate = parseFloat(priceEl.getAttribute("tax"),10);
  const taxEl = priceEl.querySelector(".price-info__tax-info span");
  const regex = /\d{1,3}(?:\.\d{3})*,\d{1,2}/;
  const originalPercentage = percentageElement && percentageElement.innerHTML ;
  const compareAtPriceElOriginal = compareAtPriceEl && compareAtPriceEl.innerHTML;
  const taxElOriginal = taxEl.innerHTML;
  let productPrice;
  let referencePrice;

  const initKachingBundleApp = () => {
    const kachingBundleBlock = kachingBundle.querySelector(".kaching-bundles");
    const quantitySelectorInput = quantitySelector === null ? null :  quantitySelector.querySelector("input");
    if (!kachingBundleBlock) return;

    const { product, dealBlock } = kachingBundleBlock;

    if (!dealBlock) {
      return;
    }

    if (!product?.availableForSale) {
      kachingBundle.style.display = "none";
      return;
    }
    initialized = true;
    productPrice = parseFloat(product.variants[0].price) / 100;
    referencePrice = product.variants[0].compareAtPrice ? parseFloat(product.variants[0].compareAtPrice) / 100 : parseFloat(product.variants[0].price) / 100;

    quantitySelector.style.display = "flex";

    const deals = dealBlock.dealBars.map(({ id, quantity, discountType, discountValue }) => ({
      id,
      quantity,
      type: discountType,
      value: discountValue,
    }));

    kachingBundle.querySelectorAll(".kaching-bundles__bar input").forEach((input) => {
      const deal = deals.find((item) => item.id === input.value);
      if (deal) updateDiscountDisplay(input, deal);

      input.addEventListener("input", () => handleInputChange(input, deals, quantitySelectorInput));
    });

    quantitySelector.addEventListener("changeQuantity", (ev) => handleQuantityChange(ev, deals));
  };

  const updateDiscountDisplay = (input, deal) => {
    let newValue;
    if (deal.type === "amount") {
      newValue = (productPrice - deal.value).toFixed(2);
      input.parentElement.querySelector(".kaching-bundles__bar-full-price").innerHTML = `-${calcPercentage(newValue)}%`;
    } else if (deal.type === "percentage") {
      newValue = (productPrice - productPrice * (deal.value / 100)).toFixed(2);
      input.parentElement.querySelector(".kaching-bundles__bar-full-price").innerHTML = `-${deal.value + parseInt(getNumberBetweenDashAndPercent(originalPercentage))}%`;
    } else if (deal.type === "specific") {
      newValue = (deal.value / 10).toFixed(2);
      input.parentElement.querySelector(".kaching-bundles__bar-full-price").innerHTML = `-${calcPercentage(newValue)}%`;
    }
  };

  const handleInputChange = (input, deals, quantitySelectorInput) => {
    if(compareAtPriceEl && productPrice === referencePrice){
      compareAtPriceEl.innerHTML = compareAtPriceEl.innerHTML.replace(regex, productPrice.toFixed(2));
    }
    const inputDealData = deals.find((item) => item.id === input.value);
    quantitySelectorInput.value = inputDealData ? inputDealData.quantity : 0;
    updatePrices(inputDealData);
    quantitySelectorInput.dispatchEvent(new Event("change", { bubbles: true, cancelable: true }));
  };

  const handleQuantityChange = (ev, deals) => {
    const currentQuantity = parseInt(ev.target.quantityState.quantity, 10);
    const sortedDeals = [...deals].sort((a, b) => b.quantity - a.quantity);
    const nearestDeal = sortedDeals.find((deal) => deal.quantity <= currentQuantity);

    kachingBundle.querySelectorAll(".kaching-bundles__bar input").forEach((input) => {
      if (nearestDeal && input.value === nearestDeal.id) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true, cancelable: true }));
        updatePrices(nearestDeal);
        input.parentElement.classList.add("kaching-bundles__bar--selected");
        if( productPrice === referencePrice ){
          percentageElement.style.display = "block";
          priceEl.classList.add("text--red");
        }
      } else {
        input.checked = false;
        input.parentElement.classList.remove("kaching-bundles__bar--selected");
      }
    });

    if (!nearestDeal) resetPrices();
  };

  const updatePrices = (deal) => {
    if (!deal) return;
    let newValue;
    if (deal.type === "amount") {
      newValue = (productPrice - deal.value).toFixed(2);
      percentageElement.innerHTML = `-${calcPercentage(newValue)}%`;
    } else if (deal.type === "percentage") {
      newValue = (productPrice - productPrice * (deal.value / 100)).toFixed(2);
      percentageElement.innerHTML = `-${deal.value  + parseInt(getNumberBetweenDashAndPercent(originalPercentage))}%`;
    } else if (deal.type === "specific") {
      newValue = (deal.value / 10).toFixed(2);
      percentageElement.innerHTML = `-${calcPercentage(newValue)}%`;
    }
    pricePDP.innerHTML = pricePDP.innerHTML.replace(regex, newValue.replace(".", ","));
   // Calculate tax-inclusive price
  const taxInclusivePrice = (parseFloat(newValue) * taxRate).toFixed(2);
  taxEl.innerHTML = taxEl.innerHTML.replace(regex, taxInclusivePrice.replace(".", ","));
  };

  const resetPrices = () => {
    pricePDP.innerHTML = pricePDP.innerHTML.replace(regex, productPrice.toString().replace(".", ","));
    percentageElement.innerHTML = originalPercentage;
    
    if(compareAtPriceEl){
      compareAtPriceEl.innerHTML = compareAtPriceElOriginal;
    }
    if( productPrice === referencePrice ){
      percentageElement.style.display = "none";
      priceEl.classList.remove("text--red");
    }
  
    taxEl.innerHTML = taxElOriginal;
  };

  const calcPercentage = (newValue) => {
    return  parseInt(100 - (newValue / productPrice) * 100) + parseInt(getNumberBetweenDashAndPercent(originalPercentage))
  };

  const getNumberBetweenDashAndPercent = (input) => {
    const match = input.match(/-(\d+)%/);
    return match ? parseFloat(match[1], 10) : null; // Returns the number as an integer, or null if not found
  }

  const observer = new MutationObserver(() => {
    if (!initialized) initKachingBundleApp();
  });

  observer.observe(kachingBundle, { childList: true, subtree: true });
  initKachingBundleApp();
})();